module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/recruit_bg-04052cd1e3f5459790fd98e2cd1036d6.jpg";